module.exports = __webpack_public_path__ + "img/气泡_4@2x.15d78901.png";